module.exports = __webpack_public_path__ + "img/card03.e5d55c69.png";